import Flex from "@/shared/components/common/Flex";
import { cn } from "@/shared/libs/commonUtils";
import { ArrowsClockwise } from "@phosphor-icons/react/dist/ssr";

interface LocationSwitchProps {
  isDisable: boolean;
  handleSwtich: () => void;
}

export default function LocationSwitch({
  isDisable,
  handleSwtich,
}: LocationSwitchProps) {
  return (
    <Flex
      className={cn(
        "absolute left-0 top-0 -translate-x-1/2 -translate-y-1/3 items-center justify-center p-1 z-10! bg-background rounded-full border border-border",
        isDisable
          ? "cursor-not-allowed disabled"
          : "cursor-pointer hover:rotate-180 transition duration-150 ease-ease-in-out-quint",
      )}
      onClick={handleSwtich}
    >
      <ArrowsClockwise
        className={cn(
          "w-6 h-6",
          isDisable ? "text-muted-foreground" : "text-foreground",
        )}
      />
    </Flex>
  );
}
